import { render, staticRenderFns } from "./PlansSubPage.vue?vue&type=template&id=018cff61&"
import script from "./PlansSubPage.vue?vue&type=script&lang=ts&"
export * from "./PlansSubPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports